export default () =>{
    const pageName = document.body.dataset.pageName;

    const header = document.querySelector('.header');
    const headerSubmenus = header.querySelectorAll('[data-set-active]');

    headerSubmenus.forEach(el =>{
        const links = el.querySelectorAll('a');
        links.forEach(link => link.classList.remove('active'))
        if (pageName == 'collections-archive'){
            links[0].classList.add('active')
        } else if(pageName == 'about-us' ){
            links[1].classList.add('active')
        } else if(pageName == 'blog' ){
            links[2].classList.add('active')
        } else if(pageName == 'gifts' ){
            links[3].classList.add('active')
        } 
    })
}